// extracted by mini-css-extract-plugin
export default {"EledoCreateRoot":"EledoCreateRoot_EledoCreateRoot__veRir","content-wrapper":"EledoCreateRoot_content-wrapper__4pBmH"};